import React from 'react';
import LoginContainer from '../container/LoginContainer';
import ResetPasswordForm from '../component/auth/forgotPassword';

const ForgotPasswordView = (params) => (
    <LoginContainer >
        <ResetPasswordForm />
    </LoginContainer>
)

export default ForgotPasswordView;